var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOctacoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2664_742)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2664_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4693 0.634051C19.4494 0.228075 20.5506 0.228075 21.5307 0.634051L32.6114 5.22381C33.5915 5.62979 34.3702 6.40849 34.7762 7.3886L39.3659 18.4693C39.7719 19.4494 39.7719 20.5506 39.3659 21.5307L34.7762 32.6114C34.3702 33.5915 33.5915 34.3702 32.6114 34.7762L21.5307 39.3659C20.5506 39.7719 19.4494 39.7719 18.4693 39.3659L7.3886 34.7762C6.40849 34.3702 5.62979 33.5915 5.22381 32.6114L0.634051 21.5307C0.228075 20.5506 0.228075 19.4494 0.634051 18.4693L5.22381 7.3886C5.62979 6.40849 6.40849 5.62979 7.3886 5.22381L18.4693 0.634051Z",
    fill: "url(#paint0_linear_2664_742)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.6606 1.09599C19.5182 0.740762 20.4818 0.740762 21.3394 1.09599L32.4201 5.68575C33.2777 6.04098 33.959 6.72234 34.3142 7.57994L38.904 18.6606C39.2592 19.5182 39.2592 20.4818 38.904 21.3394L34.3142 32.4201C33.959 33.2777 33.2777 33.959 32.4201 34.3142L21.3394 38.904C20.4818 39.2592 19.5182 39.2592 18.6606 38.904L7.57994 34.3142C6.72234 33.959 6.04098 33.2777 5.68575 32.4201L1.09599 21.3394C0.740762 20.4818 0.740762 19.5182 1.09599 18.6606L5.68575 7.57994C6.04098 6.72234 6.72234 6.04098 7.57994 5.68575L18.6606 1.09599Z",
    stroke: "url(#paint1_linear_2664_742)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2664_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 31C16.8756 31 14.4279 30.0703 12.6567 28.2108C10.8856 26.3514 10 23.5727 10 19.8746C10 18.2868 10.2488 16.8243 10.7463 15.4872C11.2438 14.15 11.9303 13.0009 12.806 12.0399C13.7015 11.0788 14.7662 10.3371 16 9.81482C17.2338 9.27161 18.597 9 20.0896 9C21.5423 9 22.8756 9.26116 24.0896 9.78348C25.3035 10.2849 26.3483 11.0057 27.2239 11.9459C28.0995 12.886 28.7761 14.0247 29.2537 15.3618C29.7512 16.6781 30 18.151 30 19.7806C30 21.5983 29.7313 23.207 29.194 24.6068C28.6766 25.9858 27.9602 27.1557 27.0448 28.1168C26.1493 29.057 25.0945 29.7778 23.8806 30.2792C22.6667 30.7597 21.3731 31 20 31ZM20.1194 29.6838C21.0945 29.6838 21.9502 29.4122 22.6866 28.8689C23.4428 28.3257 24.0796 27.6154 24.597 26.7379C25.1144 25.8395 25.5025 24.8158 25.7612 23.6667C26.0398 22.4967 26.1791 21.2849 26.1791 20.0313C26.1791 18.8196 26.0697 17.6287 25.8507 16.4587C25.6517 15.2887 25.3134 14.2545 24.8358 13.3561C24.3582 12.4368 23.7214 11.7056 22.9254 11.1624C22.1294 10.5983 21.1542 10.3162 20 10.3162C18.9254 10.3162 17.99 10.5983 17.194 11.1624C16.4179 11.7265 15.7811 12.4682 15.2836 13.3875C14.7861 14.2859 14.4179 15.32 14.1791 16.49C13.9403 17.6391 13.8209 18.8091 13.8209 20C13.8209 21.2536 13.9204 22.4653 14.1194 23.6353C14.3184 24.8053 14.6567 25.8395 15.1343 26.7379C15.6119 27.6154 16.2488 28.3257 17.0448 28.8689C17.8607 29.4122 18.8856 29.6838 20.1194 29.6838Z",
    fill: "#6D6C73"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2664_742",
    x: 0.32959,
    y: 0.329102,
    width: 39.3408,
    height: 39.3418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2664_742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2664_742",
    x: 0.32959,
    y: 0.329102,
    width: 39.3408,
    height: 39.3418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2664_742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2664_742",
    x: 10,
    y: 9,
    width: 20,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2664_742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2664_742",
    x1: 3.5,
    y1: 3,
    x2: 36.5,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200940",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C8C8C8",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C8C8C8",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200940",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2664_742",
    x1: 20,
    y1: -5.09804,
    x2: 20,
    y2: 46.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200940",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C8C8C8",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C8C8C8",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200940",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctacoinIcon);
export default __webpack_public_path__ + "static/media/OctacoinIcon.7a9de94a4d2f8cd7b22bd3fa3b6c00c8.svg";
export { ForwardRef as ReactComponent };